import { createAction } from 'redux-actions';
import {
  REQUEST_CURRENT_USER_SUCCESS,
  REQUEST_CURRENT_USER_FAILURE
} from '../constants/actionTypes';

import * as User from '../api/users';
import { showErrorSnackbar } from './snackbar';
import { logout } from './authentication';

/* eslint-disable import/prefer-default-export */
const requestUserSuccess = createAction(REQUEST_CURRENT_USER_SUCCESS);
const requestUserFailure = createAction(REQUEST_CURRENT_USER_FAILURE);

export function requestCurrentUser() {
  return dispatch => User.requestCurrentUser()
     .then(({ data }) => {console.log("user data",data);dispatch(requestUserSuccess(data))})
    .catch(error => {
      dispatch(requestUserFailure(error));
      if (error?.response?.status === 401) {
        dispatch(showErrorSnackbar('Session is Expired!!!'));
        dispatch(logout());
      }
      dispatch(showErrorSnackbar(error?.response?.data?.errors?.error));
    });
}
